export default __webpack_public_path__ + "static/media/red_dress.2f7337f1.jpeg";